import { QUOTA_EXCEEDED_CODE } from '../constants/errorCodes';
import { logWarning } from './remoteLogger';

const localStorage = {
  get: <T>(key: string): string | T | null => {
    const data = window.localStorage.getItem(key);

    try {
      if (data === null) return null;
      return JSON.parse(data) as T;
    } catch (error: any) {
      logWarning(
        '[localStorage]',
        `Failed to parse JSON for key: ${key}`,
        error
      );
      return null;
    }
  },

  set: (key: string, value: any) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e: any) {
      if (e.name === 'QuotaExceededError' || e.code === QUOTA_EXCEEDED_CODE) {
        logWarning('[localStorage]', 'Quota exceeded — clearing storage');
        window.localStorage.clear();

        try {
          window.localStorage.setItem(key, JSON.stringify(value));
          logWarning('[localStorage]', 'Item set successfully after clear.');
        } catch (retryError: any) {
          logWarning(
            '[localStorage]',
            'Failed to set item even after clear:',
            retryError
          );
        }
      } else {
        logWarning('[localStorage]', 'Failed to set item:', e);
      }
    }
  },

  remove: (key: string) => {
    window.localStorage.removeItem(key);
  },

  clear: () => {
    window.localStorage.clear();
  },
};

export default localStorage;
